var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.rateLimitShowContents,
      "widget-title": _vm.$t("HEADER_RATE_LIMIT")
    },
    on: {
      onShowContentsClick: function($event) {
        return _vm.onRateLimitShowContentsClick()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", name: "rateLimit" }
              },
              [
                _vm.overridesAvailable
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_OVERRIDE_RATE_LIMIT"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "TOOLTIP_OVERRIDE_RATE_LIMIT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "p-l-0 col-sm-5 col-md-1"
                                      },
                                      [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c("nzToggle", {
                                              attrs: {
                                                value:
                                                  _vm.overrideRateLimitSettings,
                                                "data-cy":
                                                  "rate-limit-overide-toggle"
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.overrideRateLimitSettingsToggle
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3613871135
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.overridesAvailable || _vm.overrideRateLimitSettings
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_MAXIMUM_REQUESTS"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_MAXIMUM_REQUESTS")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required|min_value:1|integer",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "p-l-0 col-sm-5 col-md-1"
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control",
                                                      class: classes,
                                                      attrs: {
                                                        name:
                                                          "currentmaxRequests",
                                                        "data-cy":
                                                          "currentmaxRequests",
                                                        placeholder: _vm.$t(
                                                          "LABEL_PLACEHOLDER_MAXIMUM_REQUESTS"
                                                        ),
                                                        type: "number",
                                                        disabled:
                                                          _vm.affiliateView
                                                      },
                                                      domProps: {
                                                        value: _vm.maxRequests
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onMaximumRequestsOnInput,
                                                        change:
                                                          _vm.onMaximumRequestsOnChange,
                                                        wheel: function(
                                                          $event
                                                        ) {
                                                          return $event.target.blur()
                                                        }
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                errors[0]
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required vv-invalid",
                                                        attrs: {
                                                          name:
                                                            "currentmaxRequests-invalid-label",
                                                          "data-cy":
                                                            "currentmaxRequests-invalid-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ERROR_MAXIMUM_REQUEST"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("REQUIRED")
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1524516916
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-5 col-md-2"
                                                  },
                                                  [
                                                    _c("SearchableDropdown", {
                                                      staticClass:
                                                        "rtb-default-selector m-b-10",
                                                      class: classes,
                                                      attrs: {
                                                        value: _vm.perSeconds,
                                                        name: "perSeconds",
                                                        config:
                                                          _vm.perSecondsDropdownConfig,
                                                        disabled:
                                                          _vm.affiliateView,
                                                        searchable: false,
                                                        clearable: false
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.onPerSecondsDropdownOnChange
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1838080183
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            517805053
                          )
                        }),
                        _vm._v(" "),
                        _vm.showMaximumRequestsMessage()
                          ? _c("Field", {
                              attrs: { label: "", "hide-label": false },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        !_vm.affiliateView &&
                                        _vm.maxRequests > 0
                                          ? _c(
                                              "label",
                                              [
                                                _vm.overridesAvailable
                                                  ? [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE_MAXIMUM_REQUEST_OVERRIDE",
                                                              {
                                                                maxRequests:
                                                                  _vm.maxRequests,
                                                                period: _vm.perSeconds.toLowerCase()
                                                              }
                                                            )
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  : [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MESSAGE_MAXIMUM_REQUEST",
                                                              {
                                                                maxRequests:
                                                                  _vm.maxRequests,
                                                                period: _vm.perSeconds.toLowerCase()
                                                              }
                                                            )
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.affiliateView
                                          ? _c("label", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MESSAGE_MAXIMUM_REQUEST_AFFILIATE",
                                                      {
                                                        maxRequests:
                                                          _vm.maxRequests,
                                                        period: _vm.perSeconds.toLowerCase()
                                                      }
                                                    )
                                                  ) +
                                                  "\n            "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3203096373
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }